module.exports = "/_next/static/images/mercari-63510cdd7d00c675b2266dd94b3c5047.png";